import { DropDown, Input, toInt, useGridFilterUrlContext } from '@finbeat/react-toolkit';
import { ServiceDiscountFilter as ServiceDiscountFilterType } from 'models/api/serviceDiscount';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

const ServiceDiscountFilter = ({ tariffPlans }: { tariffPlans: DropDown[] }) => {
    const { t } = useTranslation();
    const { draftFilter, setDraftFilter } = useGridFilterUrlContext<ServiceDiscountFilterType>();
    return (
        <Row>
            <Col>
                <Input
                    type="select"
                    id="ds-tariff-plan-id-id"
                    value={draftFilter.tariffPlanId || ''}
                    onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
                        setDraftFilter((prevState) => {
                            if ('selectedIndex' in e.target) {
                                return {
                                    ...prevState,
                                    tariffPlanId: toInt(e.target.value) ?? null,
                                };
                            }
                            return prevState;
                        });
                    }}
                    label={t('BackOfficeTariffPlan')}
                    options={[<option value="" key="-1"></option>].concat(
                        tariffPlans.map((i) => (
                            <option value={i.id ?? undefined} key={i.id}>
                                {i.name}
                            </option>
                        ))
                    )}
                />
            </Col>
        </Row>
    );
};

export default ServiceDiscountFilter;
